// extracted by mini-css-extract-plugin
export default {"text":"text__-484e4b0e","link":"link__-484e4b0e"};